import { render, staticRenderFns } from "./BoardPd.vue?vue&type=template&id=401bf6df&scoped=true&"
import script from "./BoardPd.vue?vue&type=script&lang=js&"
export * from "./BoardPd.vue?vue&type=script&lang=js&"
import style0 from "./BoardPd.vue?vue&type=style&index=0&id=401bf6df&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401bf6df",
  null
  
)

export default component.exports